import React from "react";

import { i18n } from "../../translate/i18n";

export function WizardStepPanel({ title, description, children }) {
	return (
		<div className="space-y-4">
			{(title || description) && (
				<div>
					{title && (
						<h3 className="m-0 text-base font-semibold text-default-900 dark:text-default-50">
							{title}
						</h3>
					)}
					{description && (
						<p className="mb-0 mt-1 text-sm text-default-500 dark:text-default-400">
							{description}
						</p>
					)}
				</div>
			)}
			{children}
		</div>
	);
}

export default function WizardStepper({ steps, currentStep }) {
	if (!steps?.length) return null;

	const progress = ((currentStep + 1) / steps.length) * 100;
	const current = steps[currentStep];

	return (
		<div className="mb-6">
			<div className="mb-2 flex items-center justify-between gap-3 text-xs">
				<span className="text-default-500 dark:text-default-400">
					{i18n.t("connections.wizard.stepOf", {
						current: currentStep + 1,
						total: steps.length,
					})}
				</span>
				<span className="truncate font-medium text-default-800 dark:text-default-100">
					{current?.label}
				</span>
			</div>
			<div className="h-1 overflow-hidden rounded-full bg-default-200 dark:bg-default-700">
				<div
					className="h-full rounded-full bg-primary transition-all duration-300 ease-out"
					style={{ width: `${progress}%` }}
				/>
			</div>
		</div>
	);
}
